import React from 'react';
import { NumericFormat } from 'react-number-format';

import { TextField, type TextFieldProps } from '@mui/material';

interface FormattedNumberInputProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value: string | number;
  onChange: (value: number | null) => void;
  allowDecimals?: boolean;
  valueCondition?: (value?: string | number) => boolean;
}

export const FormattedNumberInput = React.forwardRef<HTMLInputElement, FormattedNumberInputProps>(
  (
    { value, onChange, allowDecimals = false, valueCondition = () => true, ...textFieldProps },
    ref
  ) => (
    <NumericFormat
      getInputRef={ref}
      value={value}
      onValueChange={(values) => onChange(values.floatValue ?? null)}
      thousandSeparator=","
      decimalSeparator="."
      allowNegative={false}
      decimalScale={allowDecimals ? 2 : 0}
      customInput={TextField}
      isAllowed={({ floatValue }) => valueCondition(floatValue)}
      {...(textFieldProps as any)}
    />
  )
);
